import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import IndividualInfoForm from './IndividualInfoForm';
import AccountInfoForm from './AccountInfoForm';
import ProgressSteps from './ProgressSteps';
import ArenaHeader from './ArenaHeader';
import '../../styles/monthly-registration/monthlyRegistration.css';
import '../../App.css';

export default class CustomerInfo extends Component {
  render() {
    const {
      selectedPlan,
      parkingId,
      arenaName,
      subscriptionType,
      loadingPricing,
      submittingForm,
      calculateAccountPrice,
      onBack,
      onContinueToPayment,
      booked,
      isAutoApproval
    } = this.props;

    const selectedPass = selectedPlan
      ? {
          ...selectedPlan,
          pricing_type: selectedPlan.displayName || selectedPlan.pricing_type
        }
      : null;

    return (
      <div className="monthly-registration" style={{position: 'relative'}}>
        {booked && (
          <div className="success-message">
            <svg viewBox="0 0 76 76" className="success-message__icon icon-checkmark">
              <circle cx="38" cy="38" r="36"></circle>
              <path fill="none" stroke="#FFFFFF" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M17.7,40.9l10.9,10.9l28.7-28.7" style={{strokeDashoffset: 0, strokeDasharray: 56.0029}}></path>
            </svg>
            <h3 style={{fontSize: isAutoApproval ? '1.17em' : '1em'}} className="success-message__title">{!isAutoApproval ? 'Thanks, the request is under review' : 'Sent Successfully'}</h3>
            <p style={{position: 'relative', top: '28px', fontSize: '12px', color: '#888'}}>(You can close this tab)</p>
          </div>
        )}
        {!booked && (
          <div className="monthly-registration__container">
          <ProgressSteps currentStep={2} />
          
          <div className="customer-info-header">
            <ArenaHeader arenaName={arenaName} showIntro={false} />
            <div className="customer-info-header__content">
              <h1 className="customer-info-header__title">Your Information</h1>
              <p className="customer-info-header__subtitle">
                We need some details to set up your parking account
              </p>
            </div>
          </div>

          {/* Selected Plan Section */}
          {selectedPass && (
            <div className="selected-plan-banner">
              <div className="selected-plan-banner-container">
                <p className="selected-plan-banner__label">Selected Plan</p>
                <div className="selected-plan-banner__content">
                  <span className="selected-plan-banner__name">{selectedPass.pricing_type}</span>
                  <span className="selected-plan-banner__price">
                    ${(this.props.rentalFee / 100).toLocaleString(undefined, {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0
                })}<span className="selected-plan-banner__period">{selectedPass?.subscriptionType === 'individual' ? "/month" : "/month per user"}</span>
                  </span>
                </div>
              </div>
            </div>
          )}

          {loadingPricing && (
            <div className="plan-grid__empty">
              <p>Loading pricing information...</p>
            </div>
          )}

          {!loadingPricing && subscriptionType === 'individual' && (
            <IndividualInfoForm
              selectedPass={selectedPass}
              parkingId={parkingId}
              onBack={onBack}
              isPayment={this.props.isPayment}
              fields={this.props.individualFields}
              alternateVehicles={this.props.alternateVehicles}
              validity={this.props.individualValidity}
              errors={this.props.individualErrors}
              showCarMakeModal={this.props.showCarMakeModal}
              showCarColorModal={this.props.showCarColorModal}
              showAlternateCarMakeModal={this.props.showAlternateCarMakeModal}
              showAlternateCarColorModal={this.props.showAlternateCarColorModal}
              currentAlternateIndex={this.props.currentAlternateIndex}
              onIndividualChange={this.props.onIndividualChange}
              onIndividualAreaCode={this.props.onIndividualAreaCode}
              onIndividualDateChange={this.props.onIndividualDateChange}
              onAddAlternateVehicle={this.props.onAddAlternateVehicle}
              onRemoveAlternateVehicle={this.props.onRemoveAlternateVehicle}
              onUpdateAlternateVehicle={this.props.onUpdateAlternateVehicle}
              onOpenCarMakeModal={this.props.onOpenCarMakeModal}
              onOpenCarColorModal={this.props.onOpenCarColorModal}
              onOpenAlternateCarMakeModal={this.props.onOpenAlternateCarMakeModal}
              onOpenAlternateCarColorModal={this.props.onOpenAlternateCarColorModal}
              onCloseModal={this.props.onCloseModal}
              onCarMakeChange={this.props.onCarMakeChange}
              onCarColorChange={this.props.onCarColorChange}
              onAlternateCarMakeChange={this.props.onAlternateCarMakeChange}
              onAlternateCarColorChange={this.props.onAlternateCarColorChange}
              onSetIndividualErrors={this.props.onSetIndividualErrors}
              onContinueToPayment={onContinueToPayment}
              submittingForm={submittingForm}
              allowAlternateVehicle={this.props.allowAlternateVehicle}
              alternateVehicleLimit={this.props.alternateVehicleLimit}
            />
          )}

          {!loadingPricing && subscriptionType === 'account' && (
            <AccountInfoForm
              selectedPass={selectedPass}
              parkingId={parkingId}
              onBack={onBack}
              isPayment={this.props.isPayment}
              fields={this.props.accountFields}
              members={this.props.members}
              validity={this.props.accountValidity}
              errors={this.props.accountErrors}
              minMembers={this.props.minMembers}
              showAccountCarMakeModal={this.props.showAccountCarMakeModal}
              showAccountCarColorModal={this.props.showAccountCarColorModal}
              currentMemberIndex={this.props.currentMemberIndex}
              currentAccountAlternateIndex={this.props.currentAccountAlternateIndex}
              onAccountChange={this.props.onAccountChange}
              onAccountAreaCode={this.props.onAccountAreaCode}
              onAccountDateChange={this.props.onAccountDateChange}
              onUpdateMember={this.props.onUpdateMember}
              onUpdateMemberAreaCode={this.props.onUpdateMemberAreaCode}
              onAddMember={this.props.onAddMember}
              onRemoveMember={this.props.onRemoveMember}
              onOpenAccountCarMakeModal={this.props.onOpenAccountCarMakeModal}
              onOpenAccountCarColorModal={this.props.onOpenAccountCarColorModal}
              onOpenAccountAlternateCarMakeModal={this.props.onOpenAccountAlternateCarMakeModal}
              onOpenAccountAlternateCarColorModal={this.props.onOpenAccountAlternateCarColorModal}
              onCloseAccountModal={this.props.onCloseAccountModal}
              onAccountCarMakeChange={this.props.onAccountCarMakeChange}
              onAccountCarColorChange={this.props.onAccountCarColorChange}
              onAddAlternateVehicleToMember={this.props.onAddAlternateVehicleToMember}
              onRemoveAlternateVehicleFromMember={this.props.onRemoveAlternateVehicleFromMember}
              onUpdateAlternateVehicleInMember={this.props.onUpdateAlternateVehicleInMember}
              onSetAccountErrors={this.props.onSetAccountErrors}
              onContinueToPayment={onContinueToPayment}
              submittingForm={submittingForm}
              allowAlternateVehicle={this.props.allowAlternateVehicle}
              alternateVehicleLimit={this.props.alternateVehicleLimit}
            />
          )}

          <ToastContainer autoClose={2000} closeButton={true} style={{ fontSize: 14 }} />
          </div>
        )}
      </div>
    );
  }
}

